var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-8 text-center text--secondary"},[_vm._v(" "+_vm._s(_vm.$t('workflowStatsComingSoon'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }